import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";
import CommonButton from "../../common/components/CommonButton";

const options = {
    BEGINNER: 'Beginner',
    INTERMEDIATE: "Intermediate",
    ADVANCED: 'Advanced'
}

const Skills = ({
    formData,
    handleInputChange,
    errors,
    setFormData
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#D4CDF9"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Skill & Experience Assessment</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Skill & Experience Assessment</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Relevant Skills You Already Have"
                            type="email"
                            name="skills"
                            value={formData.skills}
                            onChange={handleInputChange}
                            placeholder="e.g. Data Analysis"
                            error={errors.skills}
                            multiline
                        />
                    </Grid>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Tools/Languages/Platforms Familiat With"
                            type="email"
                            name="platforms"
                            value={formData.platforms}
                            onChange={handleInputChange}
                            placeholder="e.g. Python, JAVA"
                            error={errors.platforms}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <Typography fontSize={14} fontWeight={600}>Experience Level</Typography>
                        <Box display="flex" gap={1} mt={0.8}>
                            <CommonButton
                                label={options.BEGINNER}
                                width="120px"
                                fontWeight={600}
                                color={formData.experienceLevel === options.BEGINNER ? theme.palette.primary.main : theme.palette.background.dark}
                                background={formData.experienceLevel === options.BEGINNER ? theme.palette.secondary.main : 'white'}
                                handleClick={() =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        experienceLevel: options.BEGINNER
                                    }))}
                                marginBottom="0px"
                                border={`1px solid #0000001A`}
                                height="35px"
                            />
                             <CommonButton
                                label={options.INTERMEDIATE}
                                width="120px"
                                fontWeight={600}
                                color={formData.experienceLevel === options.INTERMEDIATE ? theme.palette.primary.main : theme.palette.background.dark}
                                background={formData.experienceLevel === options.INTERMEDIATE ? theme.palette.secondary.main : 'white'}
                                handleClick={() =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        experienceLevel: options.INTERMEDIATE
                                    }))}
                                marginBottom="0px"
                                border={`1px solid #0000001A`}
                                height="35px"
                            />
                             <CommonButton
                                label={options.ADVANCED}
                                width="120px"
                                fontWeight={600}
                                color={formData.experienceLevel === options.ADVANCED ? theme.palette.primary.main : theme.palette.background.dark}
                                background={formData.experienceLevel === options.ADVANCED ? theme.palette.secondary.main : 'white'}
                                handleClick={() =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        experienceLevel: options.ADVANCED
                                    }))}
                               border={`1px solid #0000001A`}
                                marginBottom="0px"
                                height="35px"
                            />
                        </Box>
                    </Grid>
                </Grid>
            }
        />
    )
}

export default Skills;